import { render, staticRenderFns } from "./ComplianceOverallBuildingCompliance.vue?vue&type=template&id=67cf6582&"
import script from "./ComplianceOverallBuildingCompliance.vue?vue&type=script&lang=ts&"
export * from "./ComplianceOverallBuildingCompliance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports